import React from 'react';
import { observer } from 'mobx-react';
import { IAddressProps } from './index';

export const AddressDefaultFormat = observer((props: IAddressProps) => {
  const { addressInputs } = props;

  return (
    <div>
      {addressInputs.recipientInput}
      {addressInputs.addressInput}
      {addressInputs.secondAddressInput}
      <div className={'container-two-columns'}>
        {addressInputs.cityInput}
        {addressInputs.stateDropDownInput}
      </div>
      <div className={'container-two-columns'}>
        {addressInputs.zipCodeInput}
        {addressInputs.countryInput}
      </div>
    </div>
  );
});
